import { regexEmail } from 'utils/utils'

export const USER_MEMBERSHIP_VALIDATION = {
    name: {
        required: 'Nama wajib diisi',
        format: {
            pattern: /^[a-zA-Z0-9&()_\-:',./\s]*$/,
            message: `Spesial karakter yang diperbolehkan hanya berupa & ( ) - _ : ' , . /`,
        },
        minimum: {
            value: 3,
            message: 'Nama minimal 3 karakter',
        },
    },
    email: {
        required: 'Email wajib diisi',
        format: {
            pattern: regexEmail,
            message: 'Format email tidak sesuai',
        },
    },
    phone_number: {
        required: 'No. Telepon wajib diisi',
        minimum: {
            value: 8,
            message: 'Nomor handphone minimal 8 angka',
        },
        format: {
            pattern: /^8[1-9][0-9]*$/,
            message: 'Nomor handphone yang di inputkan belum sesuai',
        },
    },
}
